import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DashboardHeader({ user, userBalance, onLogout }) {
  const navigate = useNavigate();
  return (
    <header className="bg-zinc-900 border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-between items-center gap-3 py-3 min-h-16">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold text-white">
              <span className="text-[#00D26A]">Flipping</span>{' '}
              <span className="text-[#FFD700]">Friends</span>
            </h1>
          </div>

          <div className="flex flex-wrap items-center gap-2 sm:gap-4 min-w-0">
            <div className="bg-black/40 border border-[#00D26A]/40 px-4 py-2 rounded-lg" data-testid="dashboard-balance">
              <div className="text-xs text-[#00D26A] font-medium uppercase tracking-wide">Balance</div>
              <div className="text-lg font-bold text-[#FFD700]">£{userBalance.toFixed(2)}</div>
            </div>

            <div className="hidden sm:flex items-center gap-3 min-w-0">
              {user?.picture && (
                <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full ring-2 ring-[#00D26A]/40" />
              )}
              <div className="text-sm min-w-0">
                <div className="font-medium text-white truncate">{user?.name}</div>
                <div className="text-zinc-500 truncate">{user?.email}</div>
              </div>
            </div>

            {user?.email?.toLowerCase() === 'barremarcus@gmail.com' && (
              <button
                onClick={() => navigate('/admin')}
                data-testid="admin-link"
                className="px-3 py-2 text-sm font-medium text-[#FFD700] bg-black/40 border border-[#FFD700]/30 hover:bg-[#FFD700]/10 rounded-md"
                title="Master library viewer"
              >
                Admin
              </button>
            )}

            <button
              onClick={() => navigate('/help')}
              data-testid="help-link"
              className="px-3 py-2 text-sm font-medium text-zinc-200 bg-black/40 border border-zinc-700 hover:bg-zinc-800 rounded-md"
            >
              Help
            </button>

            <button
              onClick={onLogout}
              data-testid="logout-button"
              className="px-4 py-2 text-sm font-medium text-zinc-200 bg-zinc-800 border border-zinc-700 rounded-md hover:bg-zinc-700"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
